import { createSlice } from '@reduxjs/toolkit';
import { query, describe } from '../../services/salesforce';
import { post } from '../../api';

export const navigatorSlice = createSlice({
    // Slice name, this should be always as page name.
    name: 'navigator',

    // Initial state for the slice
    initialState: {
        data: {},
        status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
        error: null,
    },

    // Reducers will mutate the state, put all the state mutation method over here
    reducers: {
        initialize: (state, action) => {
            state.data = action.payload;
            state.status = 'succeeded';
            state.error = null;
        },
        error: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
        loading: (state, action) => {
            state.status = action.payload ? 'loading' : 'succeeded';
        },
        initialLoading: (state, action) => {
            state.status = action.payload ? 'initialLoading' : 'succeeded';
        },
        updateSolution: (state, action) => {
            const solution = action.payload.solution;
            state.data.records = state.data.records.map((record) => {
                record.solutions = record.solutions.map((item) => {
                    if (item.id === solution.id) {
                        return solution;
                    }
                    return item;
                });
                return record;
            });
        },
    },
});

export default navigatorSlice.reducer;

// Export all the reducers actions here
export const { initialize, error, loading, initialLoading, updateSolution } = navigatorSlice.actions;

// Public Selectors
export const selectNavigatorData = (state) => state.navigator.data;
export const selectNavigatorStatus = (state) => state.navigator.status;
export const selectNavigatorError = (state) => state.navigator.error;

export const initializeAsync = (params) => async (dispatch) => {
    dispatch(initialLoading(true));
    const result = await post('custom/getSolutionCategories', {});
    if (result.isSuccess) {
        dispatch(initialize({ records: result.data }));
    } else {
        dispatch(error(result.errorMessage));
    }
};
export const initializeWithoutLoadAsync = (params) => async (dispatch) => {
    const result = await post('custom/getSolutionCategories', {});
    if (result.isSuccess) {
        dispatch(initialize({ records: result.data }));
    } else {
        dispatch(error(result.errorMessage));
    }
};

export const updateSolutionAsync = (solution) => async (dispatch) => {
    dispatch(updateSolution({ solution }));
};
